export type CreateSectorApiResponse = /** status 201  */ SectorResponseBody;
export type CreateSectorApiArg = {
  createSectorRequestBody: CreateSectorRequestBody;
};
export type GetSectorsApiResponse = /** status 200  */ SectorResponseBody[];
export type GetSectorsApiArg = {
  /** Filter by type */
  type?: SectorType;
  /** Filter by branchId */
  branchId?: string;
};
export type DeleteSectorApiResponse = unknown;
export type DeleteSectorApiArg = {
  sectorId: string;
};
export type GetSectorApiResponse = /** status 200  */ SectorResponseBody;
export type GetSectorApiArg = {
  sectorId: string;
};
export type UpdateSectorApiResponse = /** status 200  */ SectorResponseBody;
export type UpdateSectorApiArg = {
  sectorId: string;
  updateSectorRequestBody: UpdateSectorRequestBody;
};
export type GetOccupiedSpaceApiResponse = /** status 200  */ VehicleSpaceResponseBody;
export type GetOccupiedSpaceApiArg = {
  spaceType: SectorType;
  recordId: string;
};
export type UpdateOccupiedSpaceApiResponse = unknown;
export type UpdateOccupiedSpaceApiArg = {
  spaceType: SectorType;
  recordId: string;
  updateOccupiedSpaceRequestBody: UpdateOccupiedSpaceRequestBody;
};
export type GetOccupiedSpacesApiResponse = /** status 200  */ OccupiedSpaceResponseBody[];
export type GetOccupiedSpacesApiArg = {
  sectorId: string;
};
export type SectorType = 'TIRE_ORDER' | 'VEHICLE';
export type SectorResponseBody = {
  sectorId: string;
  branchId: string;
  type: SectorType;
  name: string;
  prefix: string;
  numberOfParkingSpaces: number;
};
export type CreateSectorRequestBody = {
  branchId: string;
  type: SectorType;
  name: string;
  prefix: string;
  numberOfSpaces: number;
};
export type UpdateSectorRequestBody = {
  branchId: string;
  name: string;
  prefix: string;
  numberOfSpaces: number;
};
export type DeleteSectorRequestBody = {
  sectorId: string;
};
export type VehicleSpaceResponseBody = {
  sectorId: string | null;
  prefix: string | null;
  number: number | null;
};
export type OccupiedSpaceRequestBody = {
  sectorId: string;
  number: number;
};
export type UpdateOccupiedSpaceRequestBody = {
  space: OccupiedSpaceRequestBody | null;
};
export type Occupant = {
  id: string;
  resourceId: SectorType;
  name: string;
};
export type OccupiedSpaceResponseBody = {
  id: string;
  sectorId: string;
  branchId: string;
  prefix: string;
  number: number;
  occupant: Occupant;
};
